import AssetReport from './AssetReport';

export default AssetReport;
